var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.message)?_c('v-alert',{staticStyle:{"z-index":"201"},attrs:{"border":"left","type":_vm.notificationType,"elevation":"0"}},[_c('p',{staticClass:"mb-0 caption",domProps:{"innerHTML":_vm._s(("" + _vm.message))}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }